import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import all locales
import navFR from "../locales/fr/nav.json";
import commonFR from "../locales/fr/common.json";
import homeFR from "../locales/fr/home.json";
import servicesFR from "../locales/fr/services.json";
import contactFR from "../locales/fr/contact.json";
import equipementsFR from "../locales/fr/equipements.json";
import managementFR from "../locales/fr/management.json";

import navEN from "../locales/en/nav.json";
import commonEN from "../locales/en/common.json";
import homeEN from "../locales/en/home.json";
import servicesEN from "../locales/en/services.json";
import contactEN from "../locales/en/contact.json";
import equipementsEN from "../locales/en/equipements.json";
import managementEN from "../locales/en/management.json";

const resources = {
  fr: {
    nav: navFR,
    common: commonFR,
    home: homeFR,
    services: servicesFR,
    contact: contactFR,
    equipements: equipementsFR,
    management: managementFR,
  },
  en: {
    nav: navEN,
    common: commonEN,
    home: homeEN,
    services: servicesEN,
    contact: contactEN,
    equipements: equipementsEN,
    management: managementEN,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
